module.exports = __webpack_public_path__ + "img/EntityVariable.78fbf7f6.svg";